import React, { useState } from "react";
import styles from "./project-single.module.scss";
import theme from "../styles/theme.module.scss";

function Row(props) {
  return (
    <div
      className={`${styles.row} ${theme.gdcont} ${theme.gmcont} ${theme.pT6} ${theme.pB6}`}
      style={{ backgroundColor: `${props.bgColor}`, color: `${props.textColor}` }}
    >
      <h2
        className={`${styles.row} ${theme.h5_founders} ${theme.gds1} ${theme.gde5} ${theme.mB6} ${theme.gmmain}`}
      >
        {props.row.title}
      </h2>
      <p className={`${theme.h3_tiempos} ${theme.gds6} ${theme.gde12} ${theme.gmmain}`}>
        {props.row.body}
      </p>
    </div>
  );
}

export default Row;
